import Conta from "./conta";

export default Conta;
